/**
 * Nome do contato conforme a agenda do WhatsApp da conexão.
 *
 * O backend já resolve isso ao serializar (`Aceleres::ContactAgendaName`), e na
 * maioria das telas basta ler `contact.name`. O problema é a lista de conversas
 * e o cabeçalho: os dois preferem o contato do store global (`contacts/getContact`)
 * ao `meta.sender` da conversa, e o store é chaveado só por id de contato. Um
 * número salvo por dois vendedores com nomes diferentes é UMA linha no store,
 * então a última conversa carregada decidia o nome das duas.
 *
 * Aqui o desempate é explícito: o mapa `custom_attributes.agenda_names` viaja
 * junto do contato (inclusive nos eventos de tempo real), e a inbox da conversa
 * escolhe a entrada certa.
 */

const AGENDA_ATTRIBUTE = 'agenda_names';

const agendaMap = contact => {
  const attributes =
    contact?.custom_attributes || contact?.customAttributes || null;
  const map = attributes?.[AGENDA_ATTRIBUTE];

  return map && typeof map === 'object' && !Array.isArray(map) ? map : null;
};

/**
 * @param {object} contact  contato do store ou o `meta.sender` da conversa
 * @param {number|string} inboxId  inbox da conversa em contexto
 * @param {string} fallback  nome a usar quando nenhuma agenda conhece o número
 * @returns {string}
 */
export const contactAgendaName = (contact, inboxId, fallback = '') => {
  const defaultName = contact?.name || fallback;
  if (!inboxId && inboxId !== 0) return defaultName;

  const map = agendaMap(contact);
  if (!map) return defaultName;

  const name = map[String(inboxId)];

  return typeof name === 'string' && name.trim() ? name.trim() : defaultName;
};

export default contactAgendaName;
